import React, { PropTypes } from "react";

function RemoveFromWishlistView({ labels, removeUrl, viewUrl, onRemove }) {
    return (
      <div>
        <span className="btn btn-link btn-sm active">
          <span className="icon icon-heart" /> {labels.onWishlist}
        </span>
        <div className="border-dashed">
          {removeUrl ?
            <a href="" className="btn btn-link btn-secondary btn-sm" onClick={onRemove}>
              <span className="icon icon-remove" /> {labels.removeFromWishlist}
            </a> :
            <a href={viewUrl}>{labels.gotoWishlist}</a>
                }
        </div>
      </div>
    );
}
RemoveFromWishlistView.propTypes = {
    labels: PropTypes.shape({
        onWishlist: PropTypes.string.isRequired,
        removeFromWishlist: PropTypes.string.isRequired,
    }).isRequired,
    removeUrl: PropTypes.string,
    viewUrl: PropTypes.string,
    onRemove: PropTypes.func.isRequired,
};

function AddToWishlistView({ labels, addUrl, onAdd }) {
    return (
      <a href={addUrl} className="btn btn-link btn-secondary btn-sm" onClick={onAdd}>
        <span className="icon icon-heart" /> {labels.addToWishlist}
      </a>
    );
}
AddToWishlistView.propTypes = {
    labels: PropTypes.shape({
        addToWishlist: PropTypes.string.isRequired,
    }).isRequired,
    addUrl: PropTypes.string,
    onAdd: PropTypes.func.isRequired,
};

function Feedback({ feedback, onClearFeedback }) {
    if (!feedback) {
        return null;
    }
    return (<div className={`${feedback.type}-msg`}>
      <a href="#remove-feedback" onClick={onClearFeedback} className="pull-right">X</a>
      {feedback.message}
    </div>);
}
Feedback.propTypes = {
    feedback: PropTypes.shape({
        type: PropTypes.string,
        message: PropTypes.string,
    }),
    onClearFeedback: PropTypes.func,
};

export default function WishlistView({
    product,
    labels,
    feedback,
    addUrl,
    removeUrl,
    viewUrl,
    onAdd,
    onRemove,
    onClearFeedback,
}) {
    return (
      <fieldset className="box-footer box-wishlist">
        {product.onWishlist ?
          <RemoveFromWishlistView
            labels={labels}
            removeUrl={removeUrl}
            viewUrl={viewUrl}
            onRemove={onRemove}
          /> :
            <AddToWishlistView
              labels={labels}
              addUrl={addUrl}
              onAdd={onAdd}
            />
            }

        <Feedback feedback={feedback} onClearFeedback={onClearFeedback} />
      </fieldset>
    );
}

WishlistView.propTypes = {
    product: PropTypes.shape({
        onWishlist: PropTypes.bool.isRequired,
    }).isRequired,
    labels: PropTypes.shape({}).isRequired,
    viewUrl: PropTypes.string,
    addUrl: PropTypes.string,
    removeUrl: PropTypes.string,
    feedback: PropTypes.shape({}),
    onAdd: PropTypes.func,
    onRemove: PropTypes.func,
    onClearFeedback: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src-js/Fratello/ProductPurchase/Views/WishlistView.jsx